import { apiSlice } from './apiSlice';
import { SUPPLIES_URL } from '../constants';

export const suppliesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new supply
    createSupply: builder.mutation({
      query: (supply) => ({
        url: SUPPLIES_URL,
        method: 'POST',
        body: supply,
      }),
      invalidatesTags: ['Supplies'], // Ensures the cache is updated
    }),
    // Get supply details by ID
    getSupplyDetails: builder.query({
      query: (id) => ({
        url: `${SUPPLIES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, id) => [{ type: 'Supply', id }], // Cache tag for individual supply
    }),
    // Get logged-in user's supplies
    getMySupplies: builder.query({
      query: () => ({
        url: `${SUPPLIES_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MySupplies'], // Cache tag for the user's supplies
    }),
    // Get all supplies (Admin view)
    getSupplies: builder.query({
      query: () => ({
        url: SUPPLIES_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Supplies'], // Cache tag for admin supplies
    }),
    // Mark a supply as delivered (Admin action)
    deliverSupply: builder.mutation({
      query: (supplyId) => ({
        url: `${SUPPLIES_URL}/${supplyId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, supplyId) => [{ type: 'Supply', id: supplyId }], // Invalidates cache for delivered supply
    }),
    updateSupply: builder.mutation({
          query: (data) => ({
            url: `${SUPPLIES_URL}/${data.supplyId}`,
            method: 'PUT',
            body: data, // Make sure this contains `images` as an array
          }),
          invalidatesTags: ['Supplies'],
        }),
        uploadSupplyImages: builder.mutation({ // Updated to handle multiple images
          query: (data) => ({
            url: `/api/upload`,
            method: 'POST',
            body: data, // Ensure this is a `FormData` object containing multiple images
          }),
        }),
        

    // Delete a supply (Admin action)
    deleteSupply: builder.mutation({
      query: (supplyId) => ({
        url: `${SUPPLIES_URL}/${supplyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, supplyId) => [{ type: 'Supply', id: supplyId }, 'Supplies'], // Updates supply cache
    }),
  }),
});

export const {
  useCreateSupplyMutation,
  useGetSupplyDetailsQuery,
  useGetMySuppliesQuery,
  useGetSuppliesQuery,
  useUpdateSupplyMutation,
  useUploadSupplyImagesMutation, // Updated for multiple images
  useDeliverSupplyMutation,
  useDeleteSupplyMutation,
} = suppliesApiSlice;